import React, { useState, useEffect } from 'react';
import {
  Search,
  User,
  Phone,
  FileText,
  Calendar,
  MapPin,
  Mail,
  DollarSign,
  Filter,
  RefreshCw,
  Building2,
  Users,
  AlertCircle,
  CheckCircle,
  Clock,
  XCircle,
  Eye,
  Download,
  List,
  Plus,
  ChevronDown,
  ChevronUp,
  Globe,
  ChevronLeft,
  ChevronRight,
  Share2,
  X,
  Copy,
  Facebook,
  Twitter,
  MessageSquare
} from 'lucide-react';
import apiService from '../config';
import { useLanguage } from '../StoreContext/LanguageContext';


// Punavarshan Modal Component
const PunavarshangModal = ({ isOpen, onClose, papData }) => {
    const { language, translations } = useLanguage();
  const downloadPDF = () => {
    const printWindow = window.open('', '_blank');
    const documentContent = document.getElementById('punavarshan-form').innerHTML;
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>पुनर्वसन फॉर्म</title>
          <style>
            body {
              font-family: 'Noto Sans Devanagari', 'Mangal', Arial, sans-serif;
              margin: 20px;
              line-height: 1.4;
            }
            .max-w-4xl { max-width: 100%; }
            .mx-auto { margin: 0 auto; }
            .bg-white { background: white; }
            .p-8 { padding: 32px; }
            .shadow-lg { box-shadow: none; }
            .border-2 { border: 2px solid black; }
            .border { border: 1px solid black; }
            .border-black { border-color: black; }
            .mb-4 { margin-bottom: 16px; }
            .mb-2 { margin-bottom: 8px; }
            .mb-6 { margin-bottom: 24px; }
            .mt-6 { margin-top: 24px; }
            .mt-8 { margin-top: 32px; }
            .mt-12 { margin-top: 48px; }
            .text-right { text-align: right; }
            .text-center { text-align: center; }
            .text-left { text-align: left; }
            .p-2 { padding: 8px; }
            .px-4 { padding-left: 16px; padding-right: 16px; }
            .pb-4 { padding-bottom: 16px; }
            .text-sm { font-size: 14px; }
            .text-xl { font-size: 20px; }
            .font-bold { font-weight: bold; }
            .font-semibold { font-weight: 600; }
            .leading-relaxed { line-height: 1.6; }
            .w-full { width: 100%; }
            .grid { display: grid; }
            .grid-cols-2 { grid-template-columns: repeat(2, 1fr); }
            .gap-8 { gap: 32px; }
            .border-b { border-bottom: 1px solid; }
            .border-dotted { border-style: dotted; }
            .border-gray-400 { border-color: #9ca3af; }
            .h-6 { height: 24px; }
            .flex { display: flex; }
            .justify-between { justify-content: space-between; }
            .items-end { align-items: flex-end; }
            .w-40 { width: 160px; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; }
            th { font-weight: bold; }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          ${documentContent}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-4 flex justify-between items-center">
          <h2 className="text-xl font-bold">पुनर्वसन फॉर्म</h2>
          <div className="flex gap-2">
            <button
              onClick={downloadPDF}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
            >
              <Download size={16} />
              PDF डाउनलोड करा
            </button>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        <div className="p-8">
          <div id="punavarshan-form">
            {/* Header */}
            <div className="border-2 border-black mb-4">
              <div className="text-right p-2 text-sm">
                नियम अ. क्र ९५
              </div>

              {/* <div className="text-center text-xl font-bold mb-4">
                नमुना - क
              </div> */}

              {/* Address sections */}
              <div className="px-4 pb-4 text-sm">
                <div className="mb-2">
                  <span className="font-semibold">लिहून पेपार :-</span> महाराष्ट्र शासन तर्फे उपजिल्हाधिकारी मुखपदन (म.प्र.) बुलडाणा.
                </div>
                <div className="mb-4">
                  <span className="font-semibold">लिहून पेपार :-</span> {papData?.owner_name || 'बायसुद्ध श्रीपत पाटील, बाळकृष्ण श्रीपत पाटील'}
                </div>

                {/* Main content paragraph */}
                <div className="mb-4 text-sm leading-relaxed">
                  मी / आम्ही खालील सर्व करणार पावती लिहून देतो की, मुखपदन प्रकराण क्रमांक- २८/२००८-०९
                  <br />
                  रोजी - {papData?.village_name || 'कोंडरखेड'} ता. {papData?.taluka_name || 'नांदूरा'}, जि. {papData?.district_name || 'बुलडाणा'} यामधील कायदेत कायदेवाच्या कलम २३ नुसार दिनांक ०९/०२/२०२२
                  <br />
                  रोजीच्या अंतिम निवाडयाचा पर्यंत स्वरुप व दिनांक ०४.०८.२०२२ रोजीच्या सुधारीत अंतिम निवाडयानुसार झालेल्या
                  <br />
                  मोबदला रकमेच्या तपशिलाची रक्कम रु. {papData?.total_compensation || papData?.final_amount || 0}/-( अक्षरी &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ) मला / आम्हाला मिळाले, त्यावावत माझी
                  <br />
                  / आमची कायदेशीर हक्कार नाही.
                </div>
              </div>

              {/* Table */}
              <div className="px-4 pb-4">
                <table className="w-full border border-black text-sm">
                  <thead>
                    <tr className="border border-black">
                      <th className="border border-black p-2 text-left">गावाचे नाव</th>
                      <th className="border border-black p-2 text-center">गट<br />क्रमांक</th>
                      <th className="border border-black p-2 text-center">सुधारीत<br />क्षेत्र<br />(हे.आर)</th>
                      <th className="border border-black p-2 text-center">अंतिम<br />निवाडयानुसार<br />रक्कम रुपये</th>
                      <th className="border border-black p-2 text-center">सुधारीत अंतिम<br />निवाडयानुसार<br />रक्कम रुपये</th>
                      <th className="border border-black p-2 text-center">तपशिलाची<br />रक्कम (रुपये)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border border-black">
                      <td className="border border-black p-2">{papData?.village_name || 'कोंडरखेड'} ता. {papData?.taluka_name || 'नांदूरा'}<br />जि. {papData?.district_name || 'बुलडाणा'}</td>
                      <td className="border border-black p-2 text-center">{papData?.survey_no || '१९'}</td>
                      <td className="border border-black p-2">{papData?.owner_aqr_area || ''}</td>
                      <td className="border border-black p-2">{papData?.owner_aqr_area_land_rate || ''}</td>
                      <td className="border border-black p-2">{papData?.total_compensation || papData?.final_amount || ''}</td>
                      <td className="border border-black p-2">{papData?.total_compensation || papData?.final_amount || ''}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Bottom section with dotted lines */}
            <div className="mt-6">
              <div className="text-sm font-semibold mb-4">भुधारकाची सही -</div>

              {/* Dotted lines for signatures */}
              <div className="grid grid-cols-2 gap-8 mb-6">
                <div>
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="border-b border-dotted border-gray-400 mb-4 h-6"></div>
                  ))}
                </div>
                <div>
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="border-b border-dotted border-gray-400 mb-4 h-6"></div>
                  ))}
                </div>
              </div>

              {/* Bottom signatures */}
              <div className="flex justify-between items-end mt-12">
                <div className="text-left">
                  <div className="text-sm mb-2">साक्षीदार:-</div>
                  <div className="border-b border-dotted border-gray-400 w-40 mb-6 h-6"></div>
                </div>

                <div className="text-right">
                  <div className="text-sm mb-2">समक्ष :-</div>
                  <div className="border-b border-dotted border-gray-400 w-40 mb-4 h-6"></div>
                  <div className="text-sm mt-6">
                    उपजिल्हाधिकारी मुखपदन<br />
                    (मध्यम प्रकल्प) बुलडाणा
                  </div>
                </div>
              </div>

              {/* Date */}
              <div className="text-left mt-8 text-sm">
                दिनांक :- /०३/२०२४
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Share Modal Component
const ShareModal = ({ isOpen, onClose, papData }) => {
  const [copied, setCopied] = useState(false);
      const { language, translations } = useLanguage();


  const shareUrl = `${window.location.origin}/pap/${papData?.id || ''}`;
  const shareText = `PAP Details: ${papData?.owner_name || 'Unknown'} - Compensation: ₹${papData?.total_compensation || papData?.final_amount || 0}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const shareToSocial = (platform) => {
    const encodedText = encodeURIComponent(shareText);
    const encodedUrl = encodeURIComponent(shareUrl);

    let url = '';
    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
        break;
      case 'whatsapp':
        url = `https://wa.me/?text=${encodedText} ${encodedUrl}`;
        break;
    }

    if (url) {
      window.open(url, '_blank', 'width=600,height=400');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{translations[language].SharePAPDetails}</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600 mb-2">{translations[language].PAPOwner}:</p>
            <p className="font-semibold">{papData?.owner_name || 'Unknown'}</p>
          </div>

          <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
            <input
              type="text"
              value={shareUrl}
              readOnly
              className="flex-1 bg-transparent text-sm"
            />
            <button
              onClick={copyToClipboard}
              className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 transition-colors flex items-center gap-1"
            >
              <Copy size={14} />
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>

          <div className="flex gap-3">
            <button
              onClick={() => shareToSocial('facebook')}
              className="flex-1 flex items-center justify-center gap-2 p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Facebook size={18} />
              {translations[language].Facebook}
            </button>
            <button
              onClick={() => shareToSocial('twitter')}
              className="flex-1 flex items-center justify-center gap-2 p-3 bg-sky-500 text-white rounded-lg hover:bg-sky-600 transition-colors"
            >
              <Twitter size={18} />
              {translations[language].Twitter}
            </button>
            <button
              onClick={() => shareToSocial('whatsapp')}
              className="flex-1 flex items-center justify-center gap-2 p-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              <MessageSquare size={18} />
              {translations[language].WhatsApp}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const PAP = () => {
  // STATE MANAGEMENT

  // Location dropdown states
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);

  // Selected location values
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedTaluka, setSelectedTaluka] = useState('');
  const [selectedVillage, setSelectedVillage] = useState('');

  // Project and Proposal states
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedProposal, setSelectedProposal] = useState('');
  const [selectedProjectData, setSelectedProjectData] = useState(null);
  const [selectedProposalData, setSelectedProposalData] = useState(null);

  // PAP data states
  const [allPapData, setAllPapData] = useState([]);
  const [papData, setPapData] = useState([]);
  const [filteredPapData, setFilteredPapData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);

  // Modal states
  const [showPunavarshangModal, setShowPunavarshangModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedPapForModal, setSelectedPapForModal] = useState(null);

  // Filter UI states
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [showDropdownSection, setShowDropdownSection] = useState(false);
  const [filterMode, setFilterMode] = useState('all');

  // Loading states
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingTalukas, setLoadingTalukas] = useState(false);
  const [loadingVillages, setLoadingVillages] = useState(false);
  const [loadingPapData, setLoadingPapData] = useState(false);
  const [initializing, setInitializing] = useState(true);

  // Error and success states
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // ==============================================
  // ENHANCED LOADING COMPONENT
  // ==============================================

  const Loader = ({ message = "Loading data..." }) => (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-center items-center h-80">
        <div className="text-center animate-float">
          <div className="inline-flex relative">
            <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
            <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
            </div>
          </div>
          <p className="text-gray-400 mt-4">{message}</p>
        </div>
      </div>
    </div>
  );

  // ==============================================
  // UTILITY FUNCTIONS
  // ==============================================

  const getStoredProjectData = () => {
    try {
      const storedProject = localStorage.getItem('selectedProject');
      if (storedProject) {
        const projectData = JSON.parse(storedProject);
        return {
          projectId: projectData.project_id || projectData.id,
          projectData: projectData
        };
      }

      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const defaultProjectId = userData?.data?.default_project || userData?.default_project;

      return {
        projectId: defaultProjectId,
        projectData: null
      };
    } catch (error) {
      return { projectId: null, projectData: null };
    }
  };

  const getStoredProposalData = () => {
    try {
      const currentProposalId = localStorage.getItem('currentProposalId');
      if (currentProposalId) {
        const storedProposal = localStorage.getItem('selectedProposal');
        let proposalData = null;
        if (storedProposal) {
          proposalData = JSON.parse(storedProposal);
        }

        return {
          proposalId: parseInt(currentProposalId),
          proposalData: proposalData
        };
      }

      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const defaultProposalId = userData?.data?.default_proposal ||
        userData?.data?.proposal_id ||
        userData?.default_proposal ||
        userData?.proposal_id;

      return {
        proposalId: defaultProposalId ? parseInt(defaultProposalId) : null,
        proposalData: null
      };
    } catch (error) {
      return { proposalId: null, proposalData: null };
    }
  };

  // ==============================================
  // INITIALIZATION
  // ==============================================

  useEffect(() => {
    initializeComponent();
  }, []);

  const initializeComponent = async () => {
    try {
      setInitializing(true);
      setError('');

      const { projectId, projectData } = getStoredProjectData();
      const { proposalId, proposalData } = getStoredProposalData();

      if (projectId && proposalId) {
        setSelectedProject(projectId);
        setSelectedProposal(proposalId);

        if (projectData) setSelectedProjectData(projectData);
        if (proposalData) setSelectedProposalData(proposalData);

        await loadDistricts();
        await fetchAllPAPData(projectId, proposalId);
      } else if (projectId) {
        setSelectedProject(projectId);
        if (projectData) setSelectedProjectData(projectData);
        await loadDistricts();
        setError('Proposal not found. Please select a proposal from dashboard.');
      } else {
        await loadDistricts();
        setError('No project or proposal found. Please select from dashboard.');
      }
    } catch (err) {
      setError('Failed to initialize. Please refresh the page.');
    } finally {
      setInitializing(false);
    }
  };

  // DATA FETCHING
  const fetchAllPAPData = async (projectId = selectedProject, proposalId = selectedProposal) => {
    try {
      setLoadingPapData(true);
      setError('');

      if (!projectId || !proposalId) {
        setError('Project and Proposal are required.');
        return;
      }

      const response = await apiService.getPAP(projectId, proposalId);
      const papDataArray = response?.data || [];

      setAllPapData(papDataArray);
      setPapData(papDataArray);
      setFilteredPapData(papDataArray);
      setCurrentPage(1); // Reset to first page

      if (papDataArray.length === 0) {
        setError('No PAP data found for this project and proposal.');
      } else {
        setSuccessMessage(`Loaded ${papDataArray.length} PAP records`);
        setTimeout(() => setSuccessMessage(''), 3000);
      }

    } catch (err) {
      if (err.message.includes('Network error')) {
        setError('Network error. Please check your connection.');
      } else if (err.message.includes('404')) {
        setError('No PAP data found for selected criteria.');
      } else {
        setError('Failed to fetch PAP data. Please try again.');
      }

      setAllPapData([]);
      setPapData([]);
      setFilteredPapData([]);
    } finally {
      setLoadingPapData(false);
    }
  };

  const loadDistricts = async () => {
    try {
      setLoadingDistricts(true);
      const response = await apiService.getDistricts();
      const districtsArray = Array.isArray(response?.data) ? response.data : [];
      setDistricts(districtsArray);
    } catch (err) {
      setDistricts([]);
    } finally {
      setLoadingDistricts(false);
    }
  };

  const loadTalukas = async () => {
    try {
      setLoadingTalukas(true);
      const selectedDistrictObj = districts.find(d =>
        d.dist_name === selectedDistrict || d.district_name === selectedDistrict
      );

      if (selectedDistrictObj) {
        const distNo = selectedDistrictObj.dist_name || selectedDistrictObj.district_name;
        const response = await apiService.getTalukas(distNo);
        const talukasArray = Array.isArray(response?.data) ? response.data : [];
        setTalukas(talukasArray);
      }
    } catch (err) {
      setTalukas([]);
    } finally {
      setLoadingTalukas(false);
    }
  };

  const loadVillages = async () => {
    try {
      setLoadingVillages(true);
      const selectedDistrictObj = districts.find(d =>
        d.dist_name === selectedDistrict || d.district_name === selectedDistrict
      );
      const selectedTalukaObj = talukas.find(t =>
        t.taluka_name === selectedTaluka || t.tehsil_name === selectedTaluka
      );

      if (selectedDistrictObj && selectedTalukaObj) {
        const distNo = selectedDistrictObj.dist_name || selectedDistrictObj.district_name;
        const tehsilNo = selectedTalukaObj.taluka_name || selectedTalukaObj.tehsil_name;
        const response = await apiService.getVillages(distNo, tehsilNo);
        const villagesArray = Array.isArray(response?.data) ? response.data : [];
        setVillages(villagesArray);
      }
    } catch (err) {
      setVillages([]);
    } finally {
      setLoadingVillages(false);
    }
  };

  // PDF DOWNLOAD FUNCTION
  const downloadPAPsPDF = () => {
    const printWindow = window.open('', '_blank');

    const generatePDFContent = () => {
      const totalPages = Math.ceil(filteredPapData.length / 6);
      let pdfContent = '';

      for (let page = 0; page < totalPages; page++) {
        const startIndex = page * 6;
        const endIndex = Math.min(startIndex + 6, filteredPapData.length);
        const pageData = filteredPapData.slice(startIndex, endIndex);

        pdfContent += `
          <div class="page ${page > 0 ? 'page-break' : ''}">
            <div class="header">
              <h1>Project Affected Persons (PAP)</h1>
              <div class="project-info">
                <p><strong>Project:</strong> ${selectedProjectData?.project_name || 'N/A'}</p>
                <p><strong>Proposal No:</strong> ${selectedProposalData?.acquisition_proposal_no || 'N/A'}</p>
                <p><strong>No of Occupants:</strong> ${filteredPapData.length}</p>
              </div>
            </div>
            
            <div class="cards-grid">
              ${pageData.map((pap, index) => `
                <div class="pap-card">
                  <div class="card-header">
                    <h3>${pap.owner_name || pap.landholder_name || 'Unknown Owner'}</h3>
                    <span class="status ${pap.payment_done === true ? 'paid' : 'pending'}">
                      ${pap.payment_done === true ? 'Paid' : 'Pending'}
                    </span>
                  </div>
                  
                  <div class="card-content">
                    <div class="info-row">
                      <span class="label">Contact:</span>
                      <span class="value">${pap.owner_contact || 'N/A'}</span>
                    </div>
                    
                    <div class="info-row">
                      <span class="label">Email:</span>
                      <span class="value">${pap.owner_email || 'N/A'}</span>
                    </div>
                    
                    <div class="info-row">
                      <span class="label">Location:</span>
                      <span class="value">${[pap.village_name, pap.taluka_name, pap.district_name || pap.dist_name].filter(Boolean).join(', ') || 'N/A'}</span>
                    </div>
                    
                    <div class="info-row">
                      <span class="label">Survey No:</span>
                      <span class="value">${pap.survey_no || pap.surveyNo || 'N/A'}</span>
                    </div>
                    
                    <div class="info-row">
                      <span class="label">Total Area:</span>
                      <span class="value">${pap.owner_total_area || 'N/A'} ${pap.area_unit || ''}</span>
                    </div>
                    
                    <div class="info-row">
                      <span class="label">Acquire Area:</span>
                      <span class="value">${pap.owner_aqr_area || pap.aqr_area || 'N/A'} ${pap.area_unit || ''}</span>
                    </div>
                    
                    <div class="compensation-amount">
                      <span class="label">Final Amount:</span>
                      <span class="amount">₹${new Intl.NumberFormat('en-IN').format(parseFloat(pap.total_compensation || pap.final_amount || pap.compensation_amount || 0))}</span>
                    </div>
                  </div>
                </div>
              `).join('')}
            </div>
          </div>
        `;
      }

      return pdfContent;
    };

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>PAP Report</title>
          <style>
            @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
        }
            
            .page-break {
              page-break-before: always;
            }
            
            .header {
              text-align: center;
              margin-bottom: 20px;
              border-bottom: 2px solid #333;
              padding-bottom: 10px;
            }
            
            .header h1 {
              margin: 0 0 10px 0;
              font-size: 18px;
              color: #333;
            }
            
            .project-info {
              display: flex;
              justify-content: space-around;
              margin: 10px 0;
            }
            
            .project-info p {
              margin: 0;
              font-size: 11px;
            }
            
            .page-info {
              position: absolute;
              top: 10px;
              right: 20px;
              font-size: 10px;
              color: #666;
            }
            
            .cards-grid {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 15px;
              margin-top: 20px;
            }
            
            .pap-card {
              border: 1px solid #ddd;
              border-radius: 8px;
              padding: 12px;
              background: #fff;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            
            .card-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
              padding-bottom: 8px;
              border-bottom: 1px solid #eee;
            }
            
            .card-header h3 {
              margin: 0;
              font-size: 14px;
              color: #333;
            }
            
            .status {
              padding: 2px 8px;
              border-radius: 12px;
              font-size: 10px;
              font-weight: bold;
            }
            
            .status.paid {
              background: #d4edda;
              color: #155724;
            }
            
            .status.pending {
              background: #fff3cd;
              color: #856404;
            }
            
            .card-content {
              space-y: 5px;
            }
            
            .info-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 4px;
              font-size: 11px;
            }
            
            .label {
              font-weight: bold;
              color: #555;
            }
            
            .value {
              color: #333;
              text-align: right;
              max-width: 60%;
              word-wrap: break-word;
            }
            
            .compensation-amount {
              margin-top: 10px;
              padding-top: 8px;
              border-top: 1px solid #eee;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            
            .compensation-amount .label {
              font-size: 12px;
              color: #007bff;
            }
            
            .amount {
              font-size: 13px;
              font-weight: bold;
              color: #28a745;
            }
            
            @media print {
              body { margin: 0; padding: 10px; }
              .page-break { page-break-before: always; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          ${generatePDFContent()}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  // FILTERING LOGIC
  // Apply location filters to all PAP data
  useEffect(() => {
    let filtered = [...allPapData];

    if (filterMode === 'location') {
      if (selectedDistrict) {
        filtered = filtered.filter(pap =>
          pap.district_name === selectedDistrict || pap.dist_name === selectedDistrict
        );
      }

      if (selectedTaluka) {
        filtered = filtered.filter(pap =>
          pap.taluka_name === selectedTaluka
        );
      }

      if (selectedVillage) {
        filtered = filtered.filter(pap =>
          pap.village_name === selectedVillage
        );
      }
    }

    setPapData(filtered);
    setCurrentPage(1); // Reset to first page when filter changes
  }, [allPapData, selectedDistrict, selectedTaluka, selectedVillage, filterMode]);

  // Apply search filter
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredPapData(papData);
    } else {
      const searchLower = searchTerm.toLowerCase();
      const filtered = papData.filter(pap => {
        const searchableText = [
          pap.name, pap.owner_name, pap.landholder_name,
          pap.project_name, pap.proposal_no, pap.survey_no,
          pap.mobile_no, pap.contact_no, pap.email,
          pap.village_name, pap.taluka_name, pap.district_name, pap.dist_name
        ].filter(Boolean).join(' ').toLowerCase();

        return searchableText.includes(searchLower);
      });
      setFilteredPapData(filtered);
    }
    setCurrentPage(1); // Reset to first page when search changes
  }, [searchTerm, papData]);

  // PAGINATION LOGIC
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPapData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredPapData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // EFFECT HOOKS FOR CASCADING DROPDOWNS

  useEffect(() => {
    if (selectedDistrict) {
      setSelectedTaluka('');
      setSelectedVillage('');
      setTalukas([]);
      setVillages([]);
      loadTalukas();
    } else {
      setTalukas([]);
      setVillages([]);
      setSelectedTaluka('');
      setSelectedVillage('');
    }
  }, [selectedDistrict]);

  useEffect(() => {
    if (selectedTaluka && selectedDistrict) {
      setSelectedVillage('');
      setVillages([]);
      loadVillages();
    } else {
      setVillages([]);
      setSelectedVillage('');
    }
  }, [selectedTaluka]);

  // UTILITY FUNCTIONS
  const showAllRecords = () => {
    setFilterMode('all');
    setSelectedDistrict('');
    setSelectedTaluka('');
    setSelectedVillage('');
    setTalukas([]);
    setVillages([]);
    setPapData(allPapData);
  };
    const { language, translations } = useLanguage();

  const formatCurrency = (amount) => {
    if (!amount || isNaN(amount)) return '₹0';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(parseFloat(amount));
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-IN');
    } catch {
      return dateString;
    }
  };

  const getStatusIcon = (status) => {
    switch (String(status)) {
      case 'true':
        return <CheckCircle className="h-4 w-4 text-green-600" />;
      case 'false':
        return <Clock className="h-4 w-4 text-yellow-600" />;
      default:
        return <Clock className="h-4 w-4 text-gray-600" />;
    }
  };

  const getStatusColor = (status) => {
    switch (String(status)) {
      case 'true':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'false':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  // COMPUTED VALUES
  const totalCompensation = filteredPapData.reduce((sum, pap) => {
    const amount = parseFloat(pap.total_compensation || pap.final_amount || pap.compensation_amount || 0);
    return sum + amount;
  }, 0);

  const approvedCount = filteredPapData.filter(pap =>
    pap.payment_done === true ||
    String(pap.payment_done).toLowerCase() === 'true' ||
    pap.status?.toLowerCase() === 'approved' ||
    pap.payment_status?.toLowerCase() === 'completed'
  ).length;

  const pendingCount = filteredPapData.filter(pap =>
    pap.payment_done === false ||
    String(pap.payment_done).toLowerCase() === 'false' ||
    pap.payment_done === null ||
    pap.payment_status?.toLowerCase() === 'pending'
  ).length;

  const averageCompensation = filteredPapData.length > 0 ? totalCompensation / filteredPapData.length : 0;

  const isLocationSelectionComplete = selectedDistrict || selectedTaluka || selectedVillage;
  const canShowData = filterMode === 'all' || (filterMode === 'location' && isLocationSelectionComplete);

  // MODAL HANDLERS
  const handleViewPAP = (pap) => {
    setSelectedPapForModal(pap);
    setShowPunavarshangModal(true);
  };

  const handleSharePAP = (pap) => {
    setSelectedPapForModal(pap);
    setShowShareModal(true);
  };

  // RENDER COMPONENT
  return (
    <div className="p-4">
      {/* Modals */}
      <PunavarshangModal
        isOpen={showPunavarshangModal}
        onClose={() => setShowPunavarshangModal(false)}
        papData={selectedPapForModal}
      />

      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        papData={selectedPapForModal}
      />

      {/* Enhanced Welcome banner with Filter Options */}
      <div className="relative mb-8 bg-white rounded-xl overflow-hidden border border-gray-200 shadow-md animate-fadeIn">
        <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full filter blur-3xl opacity-40"></div>
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-gradient-to-tr from-blue-100 to-blue-200 rounded-full filter blur-3xl opacity-40"></div>

        {/* Header Section */}
        <div className="relative z-10 p-6">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            {/* Action Buttons */}
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => {
                  setFilterMode('location');
                  setShowFilterPanel(!showFilterPanel);
                  setShowDropdownSection(true);
                }}
                className="px-4 py-2 bg-gradient-to-r from-orange-700 to-orange-500 hover:from-orange-700 hover:to-orange-700 text-white rounded-lg flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-gray-200 hover:shadow-gray-300 group"
              >
                <Filter className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                <span className="font-medium">{translations[language].Filters}</span>
                {showFilterPanel ?
                  <ChevronUp className="h-4 w-4 transition-transform duration-300" /> :
                  <ChevronDown className="h-4 w-4 transition-transform duration-300" />
                }
              </button>

              <button
                onClick={() => fetchAllPAPData()}
                disabled={loadingPapData}
                className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <RefreshCw className={`h-5 w-5 group-hover:scale-110 transition-transform duration-300 ${loadingPapData ? 'animate-spin' : ''}`} />
                <span className="font-medium">{translations[language].Refresh}</span>
              </button>

              {/* Download */}
              <button
                onClick={downloadPAPsPDF}
                disabled={filteredPapData.length === 0}
                className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Download className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                <span className="font-medium">{translations[language].DownloadPDF}</span>
              </button>
            </div>
          </div>
        </div>

        {/* Collapsible Filter Panel */}
        {showFilterPanel && (
          <div className="relative z-10 border-t border-gray-200 bg-gray-50/50 backdrop-blur-sm">
            <div className="p-6 space-y-6">
              {/* Filter Mode Selection */}
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-1 bg-gray-100 rounded-lg p-1">
                  <button
                    onClick={() => setFilterMode('all')}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === 'all'
                      ? 'bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                      }`}
                  >
                    <Globe className="h-4 w-4" />
                    <span>{translations[language].AllRecords}</span>
                  </button>
                  <button
                    onClick={() => setFilterMode('location')}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === 'location'
                      ? 'bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                      }`}
                  >
                    <MapPin className="h-4 w-4" />
                    <span>{translations[language].FilterByLocation}</span>
                  </button>
                </div>

                <button
                  onClick={showAllRecords}
                  className="flex items-center gap-2 px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors duration-200"
                >
                  <List className="h-4 w-4" />
                  {translations[language].ShowAllRecords}
                </button>
              </div>

              {/* Location Selection and Search */}
              {showDropdownSection && (
                <div className="space-y-4">
                  <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
                    {/* District Dropdown */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                         {translations[language].District} <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={selectedDistrict}
                        onChange={(e) => setSelectedDistrict(e.target.value)}
                        disabled={loadingDistricts}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                      >
                        <option value="">
                          {loadingDistricts ? <span> {translations[language].LoadingDistricts}</span> : <span> {translations[language].selectDistrict}</span>}
                        </option>
                        {districts.map((district) => (
                          <option key={district.dist_name} value={district.dist_name}>
                            {district.dist_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Taluka Dropdown */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                         {translations[language].Taluka} <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={selectedTaluka}
                        onChange={(e) => setSelectedTaluka(e.target.value)}
                        disabled={!selectedDistrict || loadingTalukas}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                      >
                        <option value="">
                          {loadingTalukas ? <span> {translations[language].LoadingTalukas}</span> : <span> {translations[language].SelectTaluka}</span>}
                        </option>
                        {talukas.map((taluka) => (
                          <option key={taluka.taluka_name} value={taluka.taluka_name}>
                            {taluka.taluka_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Village Dropdown */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                         {translations[language].Village} <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={selectedVillage}
                        onChange={(e) => setSelectedVillage(e.target.value)}
                        disabled={!selectedTaluka || loadingVillages}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                      >
                        <option value="">
                          {loadingVillages ? <span> {translations[language].LoadingVillages}</span> : <span> {translations[language].SelectVillage}</span>}
                        </option>
                        {villages.map((village) => (
                          <option key={village.village_name} value={village.village_name}>
                            {village.village_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Enhanced Search Input */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        {translations[language].Search}
                      </label>
                      <div className="relative group">
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-2xl blur-sm opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                        <div className="relative">
                          <input
                            type="text"
                            placeholder={translations[language].SearchPAPs}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full pl-12 pr-12 py-2 rounded-2xl bg-white border-2 border-gray-200 text-gray-700 placeholder-gray-500 
                              focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100 focus:shadow-lg
                              hover:border-gray-300 hover:shadow-md
                              transition-all duration-300 font-medium text-sm"
                          />
                          <div className="absolute left-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                            <div className="p-1 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-sm">
                              <Search className="h-4 w-4" />
                            </div>
                          </div>
                          {searchTerm && (
                            <button
                              onClick={() => setSearchTerm('')}
                              className="absolute right-4 top-1/2 transform -translate-y-1/2 p-1.5 rounded-full bg-gray-200 hover:bg-red-100 text-gray-500 hover:text-red-600 transition-all duration-200 hover:scale-110"
                              title="Clear search"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {filterMode === 'location' && !isLocationSelectionComplete && (
                    <p className="text-sm text-amber-600">
                      {translations[language].SelectLocationMessage}
                    </p>
                  )}

                  {/* Filter Info */}
                  {filterMode === 'location' && (selectedDistrict || selectedTaluka || selectedVillage) && (
                    <div className="p-3 bg-blue-50 rounded-lg">
                      <div className="flex items-center gap-2 text-sm text-blue-700">
                        <MapPin className="h-4 w-4" />
                        <span>
                          {translations[language].FilteredBy}: {[selectedDistrict, selectedTaluka, selectedVillage].filter(Boolean).join(' → ')}
                        </span>
                        <span className="text-blue-600">
                          ({filteredPapData.length} of {allPapData.length} records)
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Initializing State - Enhanced Loading */}
      {initializing && (
        <Loader message={translations[language].InitializingPAPData} />
      )}

      {/* Success Message */}
      {successMessage && !initializing && (
        <div className="bg-white rounded-xl shadow-sm border border-green-200 p-6 mb-6">
          <div className="bg-green-50 rounded-lg p-4">
            <div className="flex items-center">
              <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
              <span className="text-green-800 font-medium">{successMessage}</span>
            </div>
          </div>
        </div>
      )}

      {/* Error Message */}
      {error && !initializing && (
        <div className="bg-white rounded-xl shadow-sm border border-red-200 p-6 mb-6">
          <div className="bg-red-50 rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div className="flex items-center">
                <AlertCircle className="h-5 w-5 text-red-600 mr-2 flex-shrink-0" />
                <span className="text-red-800 font-medium">{error}</span>
              </div>
              <button
                onClick={() => fetchAllPAPData()}
                className="ml-4 px-4 py-2 bg-red-600 text-white text-sm rounded-lg hover:bg-red-700 transition-colors duration-200"
              >
                {translations[language].Retry}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading State - Enhanced Loading */}
      {loadingPapData && !initializing && (
        <Loader message="Loading PAP data..." />
      )}

      {/* Show content when filter conditions are met */}
      {canShowData && (
        <>
          {/* Summary Stats */}
          {filteredPapData.length > 0 && !loadingPapData && !initializing && (
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div className="bg-white rounded-lg shadow-md p-6 border border-blue-200">
                <div className="flex items-center gap-3">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    <Users className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">{translations[language].TotalPAPs}</p>
                    <p className="text-2xl font-bold text-blue-600">{filteredPapData.length}</p>
                    {allPapData.length !== filteredPapData.length && (
                      <p className="text-xs text-gray-500">{translations[language].of} {allPapData.length}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6 border border-green-200">
                <div className="flex items-center gap-3">
                  <div className="bg-green-100 p-3 rounded-lg">
                    <DollarSign className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">{translations[language].TotalCompensation}</p>
                    <p className="text-lg font-bold text-green-600">
                      {formatCurrency(totalCompensation)}
                    </p>
                    <p className="text-xs text-gray-500">
                      {translations[language].Average}: {formatCurrency(averageCompensation)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6 border border-emerald-200">
                <div className="flex items-center gap-3">
                  <div className="bg-emerald-100 p-3 rounded-lg">
                    <CheckCircle className="h-6 w-6 text-emerald-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">{translations[language].Paid}</p>
                    <p className="text-2xl font-bold text-emerald-600">{approvedCount}</p>
                    <p className="text-xs text-gray-500">
                      {filteredPapData.length > 0 ? Math.round((approvedCount / filteredPapData.length) * 100) : 0}%
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6 border border-yellow-200">
                <div className="flex items-center gap-3">
                  <div className="bg-yellow-100 p-3 rounded-lg">
                    <Clock className="h-6 w-6 text-yellow-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">{translations[language].Pending}</p>
                    <p className="text-2xl font-bold text-yellow-600">{pendingCount}</p>
                    <p className="text-xs text-gray-500">
                      {filteredPapData.length > 0 ? Math.round((pendingCount / filteredPapData.length) * 100) : 0}%
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* PAP Cards Grid with Pagination */}
          {currentItems.length > 0 && !loadingPapData && !initializing && (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                {currentItems.map((pap, index) => (
                  <div key={pap.id || pap.owner_id || pap.comp_id || index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100">
                    {/* Card Header */}
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4">
                      <div className="flex items-center gap-3">
                        <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                          <User className="h-6 w-6 text-white" />
                        </div>
                        <div className="flex-1">
                          <h3 className="text-lg font-semibold text-white truncate">
                            {pap.owner_name || pap.landholder_name || 'Unknown Owner'}
                          </h3>
                          <div className="flex items-center gap-2 mt-1">
                            <span
                              className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(pap.payment_done)}`}
                            >
                              {getStatusIcon(pap.payment_done)}
                              <span className="ml-1">
                                {pap.payment_done === true || String(pap.payment_done).toLowerCase() === 'true'
                                  ? 'Paid'
                                  : pap.payment_done === false || String(pap.payment_done).toLowerCase() === 'false'
                                    ? 'Pending'
                                    : pap.payment_done === null
                                      ? 'Pending'
                                      : 'Unknown'}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Card Content */}
                    <div className="p-6 space-y-4">
                      {/* Contact Information */}
                      <div className="space-y-3">
                        <div className="flex items-center gap-3">
                          <Phone className="h-4 w-4 text-blue-500 flex-shrink-0" />
                          <span className="text-sm text-gray-700 font-medium">
                            {pap.owner_contact || 'Not provided'}
                          </span>
                        </div>

                        <div className="flex items-center gap-3">
                          <Mail className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span className="text-sm text-gray-700 truncate" title={pap.owner_email}>
                            {pap.owner_email || 'Not provided'}
                          </span>
                        </div>

                        <div className="flex items-center gap-3">
                          <MapPin className="h-4 w-4 text-red-500 flex-shrink-0" />
                          <span className="text-sm text-gray-700 truncate">
                            {[pap.village_name, pap.taluka_name, pap.district_name || pap.dist_name]
                              .filter(Boolean).join(', ') || 'Location not specified'}
                          </span>
                        </div>
                      </div>

                      {/* Proposal Information */}
                      <div className="bg-gray-50 rounded-lg p-4 space-y-3">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-600">{translations[language].ProposalNo}:</span>
                          <span className="text-sm text-blue-600 font-semibold">
                            {selectedProposalData?.acquisition_proposal_no || 'N/A'}
                          </span>
                        </div>

                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-600">{translations[language].SurveyNo}:</span>
                          <span className="text-sm text-gray-900 font-semibold">
                            {pap.survey_no || pap.surveyNo || 'N/A'}
                          </span>
                        </div>

                        <div className="pt-2 border-t border-gray-200">
                          <span className="text-xs font-medium text-gray-600">{translations[language].Project}:</span>
                          <p className="text-sm text-gray-900 mt-1 font-medium" title={selectedProjectData?.project_name}>
                            {selectedProjectData?.project_name || 'N/A'}
                          </p>
                        </div>
                      </div>

                      {/* Land Details */}
                      <div className="bg-blue-50 rounded-lg p-4 space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-blue-800">{translations[language].TotalArea}:</span>
                          <span className="text-sm text-blue-900 font-semibold">
                            {pap.owner_total_area || 'N/A'} {pap.area_unit || ''}
                          </span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-blue-800">{translations[language].AcquireArea}:</span>
                          <span className="text-sm text-blue-900 font-semibold">
                            {pap.owner_aqr_area || pap.aqr_area || pap.landArea || 'N/A'} {pap.area_unit || ''}
                          </span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-blue-800">{translations[language].LandRate}:</span>
                          <span className="text-sm text-blue-900 font-semibold">
                            {formatCurrency(pap.owner_aqr_area_land_rate || 0)}
                          </span>
                        </div>
                      </div>

                      {/* Final Amount */}
                      <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <DollarSign className="h-5 w-5 text-green-600" />
                            <span className="font-medium text-green-800">{translations[language].FinalAmount}</span>
                          </div>
                          <span className="text-xl font-bold text-green-700">
                            {formatCurrency(pap.total_compensation || pap.final_amount || pap.compensation_amount || 0)}
                          </span>
                        </div>
                        {pap.payment_date && (
                          <div className="mt-2 text-xs text-green-600">
                            {translations[language].PaymentDate}: {formatDate(pap.payment_date)}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Card Footer */}
                    <div className="px-6 pb-4 border-t border-gray-100">
                      <div className="flex items-center justify-between text-xs text-gray-500 pt-3">
                        <span>
                          {translations[language].PAPID}: {(pap.id || pap.owner_id || pap.pap_id || index + 1).toString().padStart(4, '0')}
                        </span>
                      </div>

                      {/* Action Buttons */}
                      <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-100 gap-2">
                        <button
                          onClick={() => handleViewPAP(pap)}
                          className="flex items-center gap-1 px-3 py-1 text-xs bg-blue-100 text-blue-700 rounded-md hover:bg-blue-200 transition-colors"
                        >
                          <Eye className="h-3 w-3" />
                          {translations[language].View}
                        </button>

                        <button
                          onClick={() => handleSharePAP(pap)}
                          className="flex items-center gap-1 px-3 py-1 text-xs bg-green-100 text-green-700 rounded-md hover:bg-green-200 transition-colors"
                        >
                          <Share2 className="h-3 w-3" />
                          {translations[language].Share}
                        </button>

                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-400">
                            {translations[language].Updated}: {formatDate(pap.last_upd_dt || pap.cre_usr_dt)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex items-center justify-between bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <span>
                      {translations[language].showing} {indexOfFirstItem + 1} {translations[language].to} {Math.min(indexOfLastItem, filteredPapData.length)} {translations[language].of} {filteredPapData.length} {translations[language].results}
                    </span>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => paginate(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                      <ChevronLeft className="h-4 w-4" />
                    </button>

                    <div className="flex gap-1">
                      {[...Array(totalPages)].map((_, index) => {
                        const page = index + 1;
                        const shouldShow = page === 1 || page === totalPages || (page >= currentPage - 2 && page <= currentPage + 2);

                        if (!shouldShow && page === currentPage - 3) {
                          return <span key={page} className="px-3 py-2 text-gray-400">...</span>;
                        }
                        if (!shouldShow && page === currentPage + 3) {
                          return <span key={page} className="px-3 py-2 text-gray-400">...</span>;
                        }
                        if (!shouldShow) return null;

                        return (
                          <button
                            key={page}
                            onClick={() => paginate(page)}
                            className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${currentPage === page
                              ? 'bg-blue-600 text-white'
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                              }`}
                          >
                            {page}
                          </button>
                        );
                      })}
                    </div>

                    <button
                      onClick={() => paginate(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                      <ChevronRight className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}

      {/* Message when filter conditions not met */}
      {!canShowData && !loadingPapData && !initializing && filterMode === 'location' && (
        <div className="text-center py-12">
          <MapPin className="h-16 w-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 text-lg">{translations[language].SelectLocationToViewData}</p>
        </div>
      )}

      {/* No Data State */}
      {!loadingPapData && !initializing && filteredPapData.length === 0 && selectedProject && selectedProposal && !error && canShowData && (
        <div className="text-center py-12 bg-white rounded-xl shadow-lg">
          <Search className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">{translations[language].NoPAPDataFound}</h3>
          <p className="text-gray-600 mb-4">
            {translations[language].NoProjectAffectedPersons}
          </p>
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={() => setSearchTerm('')}
              className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
            >
              {translations[language].ClearSearch}
            </button>
            <button
              onClick={showAllRecords}
              className="px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors"
            >
              {translations[language].ShowAllRecords}
            </button>
          </div>
        </div>
      )}

      {/* Instructions */}
      {!selectedProject && !error && !initializing && (
        <div className="text-center py-12 bg-white rounded-xl shadow-lg">
          <AlertCircle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">{translations[language].NoProjectSelected}</h3>
          <p className="text-gray-600 mb-4">
           {translations[language].GoBackMessage}
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors"
          >
            {translations[language].GoBackToDashboard}
          </button>
        </div>
      )}

      {/* Custom CSS for animation */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-in-out;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default PAP;